// Generated from Postcode Sectors-All Launched.csv on 2026-07-02.
// Exact postcode-sector matches only; do not add district fallback here.
window.BC_NATIVE_DELIVERY_ZONES = {
  "version": "2026-07-02",
  "source": "Postcode Sectors-All Launched.csv",
  "launchedSectorCount": 825,
  "launchedByDay": {
    "Saturday": 398,
    "Sunday": 427
  },
  "sectors": {
    "BR14": {
      "day": "Saturday",
      "sector": "BR1 4",
      "district": "BR1"
    },
    "BR15": {
      "day": "Saturday",
      "sector": "BR1 5",
      "district": "BR1"
    },
    "BR31": {
      "day": "Saturday",
      "sector": "BR3 1",
      "district": "BR3"
    },
    "BR34": {
      "day": "Saturday",
      "sector": "BR3 4",
      "district": "BR3"
    },
    "BR35": {
      "day": "Saturday",
      "sector": "BR3 5",
      "district": "BR3"
    },
    "CR78": {
      "day": "Saturday",
      "sector": "CR7 8",
      "district": "CR7"
    },
    "E10": {
      "day": "Saturday",
      "sector": "E1 0",
      "district": "E1"
    },
    "E11": {
      "day": "Saturday",
      "sector": "E1 1",
      "district": "E1"
    },
    "E12": {
      "day": "Saturday",
      "sector": "E1 2",
      "district": "E1"
    },
    "E13": {
      "day": "Saturday",
      "sector": "E1 3",
      "district": "E1"
    },
    "E14": {
      "day": "Saturday",
      "sector": "E1 4",
      "district": "E1"
    },
    "E15": {
      "day": "Saturday",
      "sector": "E1 5",
      "district": "E1"
    },
    "E16": {
      "day": "Saturday",
      "sector": "E1 6",
      "district": "E1"
    },
    "E17": {
      "day": "Saturday",
      "sector": "E1 7",
      "district": "E1"
    },
    "E18": {
      "day": "Saturday",
      "sector": "E1 8",
      "district": "E1"
    },
    "E19": {
      "day": "Saturday",
      "sector": "E1 9",
      "district": "E1"
    },
    "E1W1": {
      "day": "Saturday",
      "sector": "E1W 1",
      "district": "E1W"
    },
    "E1W2": {
      "day": "Saturday",
      "sector": "E1W 2",
      "district": "E1W"
    },
    "E1W3": {
      "day": "Saturday",
      "sector": "E1W 3",
      "district": "E1W"
    },
    "E1W9": {
      "day": "Saturday",
      "sector": "E1W 9",
      "district": "E1W"
    },
    "E20": {
      "day": "Saturday",
      "sector": "E2 0",
      "district": "E2"
    },
    "E22": {
      "day": "Saturday",
      "sector": "E2 2",
      "district": "E2"
    },
    "E26": {
      "day": "Saturday",
      "sector": "E2 6",
      "district": "E2"
    },
    "E27": {
      "day": "Saturday",
      "sector": "E2 7",
      "district": "E2"
    },
    "E28": {
      "day": "Saturday",
      "sector": "E2 8",
      "district": "E2"
    },
    "E29": {
      "day": "Saturday",
      "sector": "E2 9",
      "district": "E2"
    },
    "E35": {
      "day": "Saturday",
      "sector": "E3 5",
      "district": "E3"
    },
    "E50": {
      "day": "Saturday",
      "sector": "E5 0",
      "district": "E5"
    },
    "E55": {
      "day": "Saturday",
      "sector": "E5 5",
      "district": "E5"
    },
    "E58": {
      "day": "Saturday",
      "sector": "E5 8",
      "district": "E5"
    },
    "E59": {
      "day": "Saturday",
      "sector": "E5 9",
      "district": "E5"
    },
    "E81": {
      "day": "Saturday",
      "sector": "E8 1",
      "district": "E8"
    },
    "E82": {
      "day": "Saturday",
      "sector": "E8 2",
      "district": "E8"
    },
    "E83": {
      "day": "Saturday",
      "sector": "E8 3",
      "district": "E8"
    },
    "E84": {
      "day": "Saturday",
      "sector": "E8 4",
      "district": "E8"
    },
    "E89": {
      "day": "Saturday",
      "sector": "E8 9",
      "district": "E8"
    },
    "E95": {
      "day": "Saturday",
      "sector": "E9 5",
      "district": "E9"
    },
    "E96": {
      "day": "Saturday",
      "sector": "E9 6",
      "district": "E9"
    },
    "E97": {
      "day": "Saturday",
      "sector": "E9 7",
      "district": "E9"
    },
    "E99": {
      "day": "Saturday",
      "sector": "E9 9",
      "district": "E9"
    },
    "EC1A1": {
      "day": "Saturday",
      "sector": "EC1A 1",
      "district": "EC1A"
    },
    "EC1A2": {
      "day": "Saturday",
      "sector": "EC1A 2",
      "district": "EC1A"
    },
    "EC1A4": {
      "day": "Saturday",
      "sector": "EC1A 4",
      "district": "EC1A"
    },
    "EC1A7": {
      "day": "Saturday",
      "sector": "EC1A 7",
      "district": "EC1A"
    },
    "EC1A9": {
      "day": "Saturday",
      "sector": "EC1A 9",
      "district": "EC1A"
    },
    "EC1M3": {
      "day": "Saturday",
      "sector": "EC1M 3",
      "district": "EC1M"
    },
    "EC1M4": {
      "day": "Saturday",
      "sector": "EC1M 4",
      "district": "EC1M"
    },
    "EC1M5": {
      "day": "Saturday",
      "sector": "EC1M 5",
      "district": "EC1M"
    },
    "EC1M6": {
      "day": "Saturday",
      "sector": "EC1M 6",
      "district": "EC1M"
    },
    "EC1M7": {
      "day": "Saturday",
      "sector": "EC1M 7",
      "district": "EC1M"
    },
    "EC1N2": {
      "day": "Saturday",
      "sector": "EC1N 2",
      "district": "EC1N"
    },
    "EC1N6": {
      "day": "Saturday",
      "sector": "EC1N 6",
      "district": "EC1N"
    },
    "EC1N7": {
      "day": "Saturday",
      "sector": "EC1N 7",
      "district": "EC1N"
    },
    "EC1N8": {
      "day": "Saturday",
      "sector": "EC1N 8",
      "district": "EC1N"
    },
    "EC1P1": {
      "day": "Saturday",
      "sector": "EC1P 1",
      "district": "EC1P"
    },
    "EC1R0": {
      "day": "Saturday",
      "sector": "EC1R 0",
      "district": "EC1R"
    },
    "EC1R1": {
      "day": "Saturday",
      "sector": "EC1R 1",
      "district": "EC1R"
    },
    "EC1R3": {
      "day": "Saturday",
      "sector": "EC1R 3",
      "district": "EC1R"
    },
    "EC1R4": {
      "day": "Saturday",
      "sector": "EC1R 4",
      "district": "EC1R"
    },
    "EC1R5": {
      "day": "Saturday",
      "sector": "EC1R 5",
      "district": "EC1R"
    },
    "EC1V0": {
      "day": "Saturday",
      "sector": "EC1V 0",
      "district": "EC1V"
    },
    "EC1V1": {
      "day": "Saturday",
      "sector": "EC1V 1",
      "district": "EC1V"
    },
    "EC1V2": {
      "day": "Saturday",
      "sector": "EC1V 2",
      "district": "EC1V"
    },
    "EC1V3": {
      "day": "Saturday",
      "sector": "EC1V 3",
      "district": "EC1V"
    },
    "EC1V4": {
      "day": "Saturday",
      "sector": "EC1V 4",
      "district": "EC1V"
    },
    "EC1V7": {
      "day": "Saturday",
      "sector": "EC1V 7",
      "district": "EC1V"
    },
    "EC1V8": {
      "day": "Saturday",
      "sector": "EC1V 8",
      "district": "EC1V"
    },
    "EC1V9": {
      "day": "Saturday",
      "sector": "EC1V 9",
      "district": "EC1V"
    },
    "EC1Y0": {
      "day": "Saturday",
      "sector": "EC1Y 0",
      "district": "EC1Y"
    },
    "EC1Y1": {
      "day": "Saturday",
      "sector": "EC1Y 1",
      "district": "EC1Y"
    },
    "EC1Y2": {
      "day": "Saturday",
      "sector": "EC1Y 2",
      "district": "EC1Y"
    },
    "EC1Y4": {
      "day": "Saturday",
      "sector": "EC1Y 4",
      "district": "EC1Y"
    },
    "EC1Y7": {
      "day": "Saturday",
      "sector": "EC1Y 7",
      "district": "EC1Y"
    },
    "EC1Y8": {
      "day": "Saturday",
      "sector": "EC1Y 8",
      "district": "EC1Y"
    },
    "EC2A1": {
      "day": "Saturday",
      "sector": "EC2A 1",
      "district": "EC2A"
    },
    "EC2A2": {
      "day": "Saturday",
      "sector": "EC2A 2",
      "district": "EC2A"
    },
    "EC2A3": {
      "day": "Saturday",
      "sector": "EC2A 3",
      "district": "EC2A"
    },
    "EC2A4": {
      "day": "Saturday",
      "sector": "EC2A 4",
      "district": "EC2A"
    },
    "EC2M1": {
      "day": "Saturday",
      "sector": "EC2M 1",
      "district": "EC2M"
    },
    "EC2M2": {
      "day": "Saturday",
      "sector": "EC2M 2",
      "district": "EC2M"
    },
    "EC2M3": {
      "day": "Saturday",
      "sector": "EC2M 3",
      "district": "EC2M"
    },
    "EC2M4": {
      "day": "Saturday",
      "sector": "EC2M 4",
      "district": "EC2M"
    },
    "EC2M5": {
      "day": "Saturday",
      "sector": "EC2M 5",
      "district": "EC2M"
    },
    "EC2M6": {
      "day": "Saturday",
      "sector": "EC2M 6",
      "district": "EC2M"
    },
    "EC2M7": {
      "day": "Saturday",
      "sector": "EC2M 7",
      "district": "EC2M"
    },
    "EC2N1": {
      "day": "Saturday",
      "sector": "EC2N 1",
      "district": "EC2N"
    },
    "EC2N2": {
      "day": "Saturday",
      "sector": "EC2N 2",
      "district": "EC2N"
    },
    "EC2N3": {
      "day": "Saturday",
      "sector": "EC2N 3",
      "district": "EC2N"
    },
    "EC2N4": {
      "day": "Saturday",
      "sector": "EC2N 4",
      "district": "EC2N"
    },
    "EC2P2": {
      "day": "Saturday",
      "sector": "EC2P 2",
      "district": "EC2P"
    },
    "EC2R5": {
      "day": "Saturday",
      "sector": "EC2R 5",
      "district": "EC2R"
    },
    "EC2R6": {
      "day": "Saturday",
      "sector": "EC2R 6",
      "district": "EC2R"
    },
    "EC2R7": {
      "day": "Saturday",
      "sector": "EC2R 7",
      "district": "EC2R"
    },
    "EC2R8": {
      "day": "Saturday",
      "sector": "EC2R 8",
      "district": "EC2R"
    },
    "EC2V5": {
      "day": "Saturday",
      "sector": "EC2V 5",
      "district": "EC2V"
    },
    "EC2V6": {
      "day": "Saturday",
      "sector": "EC2V 6",
      "district": "EC2V"
    },
    "EC2V7": {
      "day": "Saturday",
      "sector": "EC2V 7",
      "district": "EC2V"
    },
    "EC2V8": {
      "day": "Saturday",
      "sector": "EC2V 8",
      "district": "EC2V"
    },
    "EC2Y5": {
      "day": "Saturday",
      "sector": "EC2Y 5",
      "district": "EC2Y"
    },
    "EC2Y8": {
      "day": "Saturday",
      "sector": "EC2Y 8",
      "district": "EC2Y"
    },
    "EC2Y9": {
      "day": "Saturday",
      "sector": "EC2Y 9",
      "district": "EC2Y"
    },
    "EC3A1": {
      "day": "Saturday",
      "sector": "EC3A 1",
      "district": "EC3A"
    },
    "EC3A2": {
      "day": "Saturday",
      "sector": "EC3A 2",
      "district": "EC3A"
    },
    "EC3A3": {
      "day": "Saturday",
      "sector": "EC3A 3",
      "district": "EC3A"
    },
    "EC3A4": {
      "day": "Saturday",
      "sector": "EC3A 4",
      "district": "EC3A"
    },
    "EC3A5": {
      "day": "Saturday",
      "sector": "EC3A 5",
      "district": "EC3A"
    },
    "EC3A6": {
      "day": "Saturday",
      "sector": "EC3A 6",
      "district": "EC3A"
    },
    "EC3A7": {
      "day": "Saturday",
      "sector": "EC3A 7",
      "district": "EC3A"
    },
    "EC3A8": {
      "day": "Saturday",
      "sector": "EC3A 8",
      "district": "EC3A"
    },
    "EC3B0": {
      "day": "Saturday",
      "sector": "EC3B 0",
      "district": "EC3B"
    },
    "EC3M1": {
      "day": "Saturday",
      "sector": "EC3M 1",
      "district": "EC3M"
    },
    "EC3M2": {
      "day": "Saturday",
      "sector": "EC3M 2",
      "district": "EC3M"
    },
    "EC3M3": {
      "day": "Saturday",
      "sector": "EC3M 3",
      "district": "EC3M"
    },
    "EC3M4": {
      "day": "Saturday",
      "sector": "EC3M 4",
      "district": "EC3M"
    },
    "EC3M5": {
      "day": "Saturday",
      "sector": "EC3M 5",
      "district": "EC3M"
    },
    "EC3M6": {
      "day": "Saturday",
      "sector": "EC3M 6",
      "district": "EC3M"
    },
    "EC3M7": {
      "day": "Saturday",
      "sector": "EC3M 7",
      "district": "EC3M"
    },
    "EC3M8": {
      "day": "Saturday",
      "sector": "EC3M 8",
      "district": "EC3M"
    },
    "EC3N1": {
      "day": "Saturday",
      "sector": "EC3N 1",
      "district": "EC3N"
    },
    "EC3N2": {
      "day": "Saturday",
      "sector": "EC3N 2",
      "district": "EC3N"
    },
    "EC3N3": {
      "day": "Saturday",
      "sector": "EC3N 3",
      "district": "EC3N"
    },
    "EC3N4": {
      "day": "Saturday",
      "sector": "EC3N 4",
      "district": "EC3N"
    },
    "EC3P3": {
      "day": "Saturday",
      "sector": "EC3P 3",
      "district": "EC3P"
    },
    "EC3R5": {
      "day": "Saturday",
      "sector": "EC3R 5",
      "district": "EC3R"
    },
    "EC3R6": {
      "day": "Saturday",
      "sector": "EC3R 6",
      "district": "EC3R"
    },
    "EC3R7": {
      "day": "Saturday",
      "sector": "EC3R 7",
      "district": "EC3R"
    },
    "EC3R8": {
      "day": "Saturday",
      "sector": "EC3R 8",
      "district": "EC3R"
    },
    "EC3V0": {
      "day": "Saturday",
      "sector": "EC3V 0",
      "district": "EC3V"
    },
    "EC3V1": {
      "day": "Saturday",
      "sector": "EC3V 1",
      "district": "EC3V"
    },
    "EC3V3": {
      "day": "Saturday",
      "sector": "EC3V 3",
      "district": "EC3V"
    },
    "EC3V4": {
      "day": "Saturday",
      "sector": "EC3V 4",
      "district": "EC3V"
    },
    "EC3V9": {
      "day": "Saturday",
      "sector": "EC3V 9",
      "district": "EC3V"
    },
    "EC4A1": {
      "day": "Saturday",
      "sector": "EC4A 1",
      "district": "EC4A"
    },
    "EC4A2": {
      "day": "Saturday",
      "sector": "EC4A 2",
      "district": "EC4A"
    },
    "EC4A3": {
      "day": "Saturday",
      "sector": "EC4A 3",
      "district": "EC4A"
    },
    "EC4A4": {
      "day": "Saturday",
      "sector": "EC4A 4",
      "district": "EC4A"
    },
    "EC4M4": {
      "day": "Saturday",
      "sector": "EC4M 4",
      "district": "EC4M"
    },
    "EC4M5": {
      "day": "Saturday",
      "sector": "EC4M 5",
      "district": "EC4M"
    },
    "EC4M6": {
      "day": "Saturday",
      "sector": "EC4M 6",
      "district": "EC4M"
    },
    "EC4M7": {
      "day": "Saturday",
      "sector": "EC4M 7",
      "district": "EC4M"
    },
    "EC4M8": {
      "day": "Saturday",
      "sector": "EC4M 8",
      "district": "EC4M"
    },
    "EC4M9": {
      "day": "Saturday",
      "sector": "EC4M 9",
      "district": "EC4M"
    },
    "EC4N1": {
      "day": "Saturday",
      "sector": "EC4N 1",
      "district": "EC4N"
    },
    "EC4N4": {
      "day": "Saturday",
      "sector": "EC4N 4",
      "district": "EC4N"
    },
    "EC4N5": {
      "day": "Saturday",
      "sector": "EC4N 5",
      "district": "EC4N"
    },
    "EC4N6": {
      "day": "Saturday",
      "sector": "EC4N 6",
      "district": "EC4N"
    },
    "EC4N7": {
      "day": "Saturday",
      "sector": "EC4N 7",
      "district": "EC4N"
    },
    "EC4N8": {
      "day": "Saturday",
      "sector": "EC4N 8",
      "district": "EC4N"
    },
    "EC4P4": {
      "day": "Saturday",
      "sector": "EC4P 4",
      "district": "EC4P"
    },
    "EC4R0": {
      "day": "Saturday",
      "sector": "EC4R 0",
      "district": "EC4R"
    },
    "EC4R1": {
      "day": "Saturday",
      "sector": "EC4R 1",
      "district": "EC4R"
    },
    "EC4R2": {
      "day": "Saturday",
      "sector": "EC4R 2",
      "district": "EC4R"
    },
    "EC4R3": {
      "day": "Saturday",
      "sector": "EC4R 3",
      "district": "EC4R"
    },
    "EC4R9": {
      "day": "Saturday",
      "sector": "EC4R 9",
      "district": "EC4R"
    },
    "EC4V2": {
      "day": "Saturday",
      "sector": "EC4V 2",
      "district": "EC4V"
    },
    "EC4V3": {
      "day": "Saturday",
      "sector": "EC4V 3",
      "district": "EC4V"
    },
    "EC4V4": {
      "day": "Saturday",
      "sector": "EC4V 4",
      "district": "EC4V"
    },
    "EC4V5": {
      "day": "Saturday",
      "sector": "EC4V 5",
      "district": "EC4V"
    },
    "EC4V6": {
      "day": "Saturday",
      "sector": "EC4V 6",
      "district": "EC4V"
    },
    "EC4Y0": {
      "day": "Saturday",
      "sector": "EC4Y 0",
      "district": "EC4Y"
    },
    "EC4Y1": {
      "day": "Saturday",
      "sector": "EC4Y 1",
      "district": "EC4Y"
    },
    "EC4Y7": {
      "day": "Saturday",
      "sector": "EC4Y 7",
      "district": "EC4Y"
    },
    "EC4Y8": {
      "day": "Saturday",
      "sector": "EC4Y 8",
      "district": "EC4Y"
    },
    "EC4Y9": {
      "day": "Saturday",
      "sector": "EC4Y 9",
      "district": "EC4Y"
    },
    "EC500": {
      "day": "Saturday",
      "sector": "EC50 0",
      "district": "EC50"
    },
    "EC501": {
      "day": "Saturday",
      "sector": "EC50 1",
      "district": "EC50"
    },
    "EC503": {
      "day": "Saturday",
      "sector": "EC50 3",
      "district": "EC50"
    },
    "EC504": {
      "day": "Saturday",
      "sector": "EC50 4",
      "district": "EC50"
    },
    "EC505": {
      "day": "Saturday",
      "sector": "EC50 5",
      "district": "EC50"
    },
    "EC506": {
      "day": "Saturday",
      "sector": "EC50 6",
      "district": "EC50"
    },
    "EC509": {
      "day": "Saturday",
      "sector": "EC50 9",
      "district": "EC50"
    },
    "EC881": {
      "day": "Saturday",
      "sector": "EC88 1",
      "district": "EC88"
    },
    "EC882": {
      "day": "Saturday",
      "sector": "EC88 2",
      "district": "EC88"
    },
    "EC883": {
      "day": "Saturday",
      "sector": "EC88 3",
      "district": "EC88"
    },
    "EC884": {
      "day": "Saturday",
      "sector": "EC88 4",
      "district": "EC88"
    },
    "EC885": {
      "day": "Saturday",
      "sector": "EC88 5",
      "district": "EC88"
    },
    "EC886": {
      "day": "Saturday",
      "sector": "EC88 6",
      "district": "EC88"
    },
    "EC887": {
      "day": "Saturday",
      "sector": "EC88 7",
      "district": "EC88"
    },
    "EC888": {
      "day": "Saturday",
      "sector": "EC88 8",
      "district": "EC88"
    },
    "EC889": {
      "day": "Saturday",
      "sector": "EC88 9",
      "district": "EC88"
    },
    "N10": {
      "day": "Saturday",
      "sector": "N1 0",
      "district": "N1"
    },
    "N11": {
      "day": "Saturday",
      "sector": "N1 1",
      "district": "N1"
    },
    "N12": {
      "day": "Saturday",
      "sector": "N1 2",
      "district": "N1"
    },
    "N13": {
      "day": "Saturday",
      "sector": "N1 3",
      "district": "N1"
    },
    "N14": {
      "day": "Saturday",
      "sector": "N1 4",
      "district": "N1"
    },
    "N15": {
      "day": "Saturday",
      "sector": "N1 5",
      "district": "N1"
    },
    "N16": {
      "day": "Saturday",
      "sector": "N1 6",
      "district": "N1"
    },
    "N17": {
      "day": "Saturday",
      "sector": "N1 7",
      "district": "N1"
    },
    "N18": {
      "day": "Saturday",
      "sector": "N1 8",
      "district": "N1"
    },
    "N19": {
      "day": "Saturday",
      "sector": "N1 9",
      "district": "N1"
    },
    "N1C4": {
      "day": "Saturday",
      "sector": "N1C 4",
      "district": "N1C"
    },
    "N41": {
      "day": "Saturday",
      "sector": "N4 1",
      "district": "N4"
    },
    "N42": {
      "day": "Saturday",
      "sector": "N4 2",
      "district": "N4"
    },
    "N43": {
      "day": "Saturday",
      "sector": "N4 3",
      "district": "N4"
    },
    "N44": {
      "day": "Saturday",
      "sector": "N4 4",
      "district": "N4"
    },
    "N49": {
      "day": "Saturday",
      "sector": "N4 9",
      "district": "N4"
    },
    "N51": {
      "day": "Saturday",
      "sector": "N5 1",
      "district": "N5"
    },
    "N52": {
      "day": "Saturday",
      "sector": "N5 2",
      "district": "N5"
    },
    "N59": {
      "day": "Saturday",
      "sector": "N5 9",
      "district": "N5"
    },
    "N64": {
      "day": "Saturday",
      "sector": "N6 4",
      "district": "N6"
    },
    "N65": {
      "day": "Saturday",
      "sector": "N6 5",
      "district": "N6"
    },
    "N66": {
      "day": "Saturday",
      "sector": "N6 6",
      "district": "N6"
    },
    "N69": {
      "day": "Saturday",
      "sector": "N6 9",
      "district": "N6"
    },
    "N70": {
      "day": "Saturday",
      "sector": "N7 0",
      "district": "N7"
    },
    "N71": {
      "day": "Saturday",
      "sector": "N7 1",
      "district": "N7"
    },
    "N76": {
      "day": "Saturday",
      "sector": "N7 6",
      "district": "N7"
    },
    "N77": {
      "day": "Saturday",
      "sector": "N7 7",
      "district": "N7"
    },
    "N78": {
      "day": "Saturday",
      "sector": "N7 8",
      "district": "N7"
    },
    "N79": {
      "day": "Saturday",
      "sector": "N7 9",
      "district": "N7"
    },
    "N80": {
      "day": "Saturday",
      "sector": "N8 0",
      "district": "N8"
    },
    "N81": {
      "day": "Saturday",
      "sector": "N8 1",
      "district": "N8"
    },
    "N87": {
      "day": "Saturday",
      "sector": "N8 7",
      "district": "N8"
    },
    "N88": {
      "day": "Saturday",
      "sector": "N8 8",
      "district": "N8"
    },
    "N89": {
      "day": "Saturday",
      "sector": "N8 9",
      "district": "N8"
    },
    "N153": {
      "day": "Saturday",
      "sector": "N15 3",
      "district": "N15"
    },
    "N155": {
      "day": "Saturday",
      "sector": "N15 5",
      "district": "N15"
    },
    "N156": {
      "day": "Saturday",
      "sector": "N15 6",
      "district": "N15"
    },
    "N160": {
      "day": "Saturday",
      "sector": "N16 0",
      "district": "N16"
    },
    "N161": {
      "day": "Saturday",
      "sector": "N16 1",
      "district": "N16"
    },
    "N165": {
      "day": "Saturday",
      "sector": "N16 5",
      "district": "N16"
    },
    "N166": {
      "day": "Saturday",
      "sector": "N16 6",
      "district": "N16"
    },
    "N167": {
      "day": "Saturday",
      "sector": "N16 7",
      "district": "N16"
    },
    "N168": {
      "day": "Saturday",
      "sector": "N16 8",
      "district": "N16"
    },
    "N169": {
      "day": "Saturday",
      "sector": "N16 9",
      "district": "N16"
    },
    "N193": {
      "day": "Saturday",
      "sector": "N19 3",
      "district": "N19"
    },
    "N194": {
      "day": "Saturday",
      "sector": "N19 4",
      "district": "N19"
    },
    "N195": {
      "day": "Saturday",
      "sector": "N19 5",
      "district": "N19"
    },
    "N199": {
      "day": "Saturday",
      "sector": "N19 9",
      "district": "N19"
    },
    "NW10": {
      "day": "Saturday",
      "sector": "NW1 0",
      "district": "NW1"
    },
    "NW11": {
      "day": "Saturday",
      "sector": "NW1 1",
      "district": "NW1"
    },
    "NW12": {
      "day": "Saturday",
      "sector": "NW1 2",
      "district": "NW1"
    },
    "NW13": {
      "day": "Saturday",
      "sector": "NW1 3",
      "district": "NW1"
    },
    "NW14": {
      "day": "Saturday",
      "sector": "NW1 4",
      "district": "NW1"
    },
    "NW17": {
      "day": "Saturday",
      "sector": "NW1 7",
      "district": "NW1"
    },
    "NW18": {
      "day": "Saturday",
      "sector": "NW1 8",
      "district": "NW1"
    },
    "NW19": {
      "day": "Saturday",
      "sector": "NW1 9",
      "district": "NW1"
    },
    "NW51": {
      "day": "Saturday",
      "sector": "NW5 1",
      "district": "NW5"
    },
    "NW52": {
      "day": "Saturday",
      "sector": "NW5 2",
      "district": "NW5"
    },
    "NW53": {
      "day": "Saturday",
      "sector": "NW5 3",
      "district": "NW5"
    },
    "NW54": {
      "day": "Saturday",
      "sector": "NW5 4",
      "district": "NW5"
    },
    "NW59": {
      "day": "Saturday",
      "sector": "NW5 9",
      "district": "NW5"
    },
    "SE10": {
      "day": "Saturday",
      "sector": "SE1 0",
      "district": "SE1"
    },
    "SE11": {
      "day": "Saturday",
      "sector": "SE1 1",
      "district": "SE1"
    },
    "SE12": {
      "day": "Saturday",
      "sector": "SE1 2",
      "district": "SE1"
    },
    "SE13": {
      "day": "Saturday",
      "sector": "SE1 3",
      "district": "SE1"
    },
    "SE14": {
      "day": "Saturday",
      "sector": "SE1 4",
      "district": "SE1"
    },
    "SE15": {
      "day": "Saturday",
      "sector": "SE1 5",
      "district": "SE1"
    },
    "SE16": {
      "day": "Saturday",
      "sector": "SE1 6",
      "district": "SE1"
    },
    "SE17": {
      "day": "Saturday",
      "sector": "SE1 7",
      "district": "SE1"
    },
    "SE18": {
      "day": "Saturday",
      "sector": "SE1 8",
      "district": "SE1"
    },
    "SE19": {
      "day": "Saturday",
      "sector": "SE1 9",
      "district": "SE1"
    },
    "SE30": {
      "day": "Saturday",
      "sector": "SE3 0",
      "district": "SE3"
    },
    "SE33": {
      "day": "Saturday",
      "sector": "SE3 3",
      "district": "SE3"
    },
    "SE37": {
      "day": "Saturday",
      "sector": "SE3 7",
      "district": "SE3"
    },
    "SE39": {
      "day": "Saturday",
      "sector": "SE3 9",
      "district": "SE3"
    },
    "SE41": {
      "day": "Saturday",
      "sector": "SE4 1",
      "district": "SE4"
    },
    "SE42": {
      "day": "Saturday",
      "sector": "SE4 2",
      "district": "SE4"
    },
    "SE49": {
      "day": "Saturday",
      "sector": "SE4 9",
      "district": "SE4"
    },
    "SE50": {
      "day": "Saturday",
      "sector": "SE5 0",
      "district": "SE5"
    },
    "SE55": {
      "day": "Saturday",
      "sector": "SE5 5",
      "district": "SE5"
    },
    "SE57": {
      "day": "Saturday",
      "sector": "SE5 7",
      "district": "SE5"
    },
    "SE58": {
      "day": "Saturday",
      "sector": "SE5 8",
      "district": "SE5"
    },
    "SE59": {
      "day": "Saturday",
      "sector": "SE5 9",
      "district": "SE5"
    },
    "SE61": {
      "day": "Saturday",
      "sector": "SE6 1",
      "district": "SE6"
    },
    "SE62": {
      "day": "Saturday",
      "sector": "SE6 2",
      "district": "SE6"
    },
    "SE63": {
      "day": "Saturday",
      "sector": "SE6 3",
      "district": "SE6"
    },
    "SE64": {
      "day": "Saturday",
      "sector": "SE6 4",
      "district": "SE6"
    },
    "SE69": {
      "day": "Saturday",
      "sector": "SE6 9",
      "district": "SE6"
    },
    "SE81": {
      "day": "Saturday",
      "sector": "SE8 1",
      "district": "SE8"
    },
    "SE83": {
      "day": "Saturday",
      "sector": "SE8 3",
      "district": "SE8"
    },
    "SE84": {
      "day": "Saturday",
      "sector": "SE8 4",
      "district": "SE8"
    },
    "SE85": {
      "day": "Saturday",
      "sector": "SE8 5",
      "district": "SE8"
    },
    "SE89": {
      "day": "Saturday",
      "sector": "SE8 9",
      "district": "SE8"
    },
    "SE101": {
      "day": "Saturday",
      "sector": "SE10 1",
      "district": "SE10"
    },
    "SE108": {
      "day": "Saturday",
      "sector": "SE10 8",
      "district": "SE10"
    },
    "SE109": {
      "day": "Saturday",
      "sector": "SE10 9",
      "district": "SE10"
    },
    "SE114": {
      "day": "Saturday",
      "sector": "SE11 4",
      "district": "SE11"
    },
    "SE115": {
      "day": "Saturday",
      "sector": "SE11 5",
      "district": "SE11"
    },
    "SE116": {
      "day": "Saturday",
      "sector": "SE11 6",
      "district": "SE11"
    },
    "SE119": {
      "day": "Saturday",
      "sector": "SE11 9",
      "district": "SE11"
    },
    "SE120": {
      "day": "Saturday",
      "sector": "SE12 0",
      "district": "SE12"
    },
    "SE122": {
      "day": "Saturday",
      "sector": "SE12 2",
      "district": "SE12"
    },
    "SE128": {
      "day": "Saturday",
      "sector": "SE12 8",
      "district": "SE12"
    },
    "SE129": {
      "day": "Saturday",
      "sector": "SE12 9",
      "district": "SE12"
    },
    "SE135": {
      "day": "Saturday",
      "sector": "SE13 5",
      "district": "SE13"
    },
    "SE136": {
      "day": "Saturday",
      "sector": "SE13 6",
      "district": "SE13"
    },
    "SE137": {
      "day": "Saturday",
      "sector": "SE13 7",
      "district": "SE13"
    },
    "SE139": {
      "day": "Saturday",
      "sector": "SE13 9",
      "district": "SE13"
    },
    "SE145": {
      "day": "Saturday",
      "sector": "SE14 5",
      "district": "SE14"
    },
    "SE146": {
      "day": "Saturday",
      "sector": "SE14 6",
      "district": "SE14"
    },
    "SE149": {
      "day": "Saturday",
      "sector": "SE14 9",
      "district": "SE14"
    },
    "SE151": {
      "day": "Saturday",
      "sector": "SE15 1",
      "district": "SE15"
    },
    "SE152": {
      "day": "Saturday",
      "sector": "SE15 2",
      "district": "SE15"
    },
    "SE153": {
      "day": "Saturday",
      "sector": "SE15 3",
      "district": "SE15"
    },
    "SE154": {
      "day": "Saturday",
      "sector": "SE15 4",
      "district": "SE15"
    },
    "SE155": {
      "day": "Saturday",
      "sector": "SE15 5",
      "district": "SE15"
    },
    "SE156": {
      "day": "Saturday",
      "sector": "SE15 6",
      "district": "SE15"
    },
    "SE159": {
      "day": "Saturday",
      "sector": "SE15 9",
      "district": "SE15"
    },
    "SE161": {
      "day": "Saturday",
      "sector": "SE16 1",
      "district": "SE16"
    },
    "SE162": {
      "day": "Saturday",
      "sector": "SE16 2",
      "district": "SE16"
    },
    "SE163": {
      "day": "Saturday",
      "sector": "SE16 3",
      "district": "SE16"
    },
    "SE164": {
      "day": "Saturday",
      "sector": "SE16 4",
      "district": "SE16"
    },
    "SE165": {
      "day": "Saturday",
      "sector": "SE16 5",
      "district": "SE16"
    },
    "SE166": {
      "day": "Saturday",
      "sector": "SE16 6",
      "district": "SE16"
    },
    "SE167": {
      "day": "Saturday",
      "sector": "SE16 7",
      "district": "SE16"
    },
    "SE169": {
      "day": "Saturday",
      "sector": "SE16 9",
      "district": "SE16"
    },
    "SE171": {
      "day": "Saturday",
      "sector": "SE17 1",
      "district": "SE17"
    },
    "SE172": {
      "day": "Saturday",
      "sector": "SE17 2",
      "district": "SE17"
    },
    "SE173": {
      "day": "Saturday",
      "sector": "SE17 3",
      "district": "SE17"
    },
    "SE179": {
      "day": "Saturday",
      "sector": "SE17 9",
      "district": "SE17"
    },
    "SE191": {
      "day": "Saturday",
      "sector": "SE19 1",
      "district": "SE19"
    },
    "SE192": {
      "day": "Saturday",
      "sector": "SE19 2",
      "district": "SE19"
    },
    "SE193": {
      "day": "Saturday",
      "sector": "SE19 3",
      "district": "SE19"
    },
    "SE199": {
      "day": "Saturday",
      "sector": "SE19 9",
      "district": "SE19"
    },
    "SE207": {
      "day": "Saturday",
      "sector": "SE20 7",
      "district": "SE20"
    },
    "SE208": {
      "day": "Saturday",
      "sector": "SE20 8",
      "district": "SE20"
    },
    "SE209": {
      "day": "Saturday",
      "sector": "SE20 9",
      "district": "SE20"
    },
    "SE217": {
      "day": "Saturday",
      "sector": "SE21 7",
      "district": "SE21"
    },
    "SE218": {
      "day": "Saturday",
      "sector": "SE21 8",
      "district": "SE21"
    },
    "SE219": {
      "day": "Saturday",
      "sector": "SE21 9",
      "district": "SE21"
    },
    "SE220": {
      "day": "Saturday",
      "sector": "SE22 0",
      "district": "SE22"
    },
    "SE222": {
      "day": "Saturday",
      "sector": "SE22 2",
      "district": "SE22"
    },
    "SE228": {
      "day": "Saturday",
      "sector": "SE22 8",
      "district": "SE22"
    },
    "SE229": {
      "day": "Saturday",
      "sector": "SE22 9",
      "district": "SE22"
    },
    "SE231": {
      "day": "Saturday",
      "sector": "SE23 1",
      "district": "SE23"
    },
    "SE232": {
      "day": "Saturday",
      "sector": "SE23 2",
      "district": "SE23"
    },
    "SE233": {
      "day": "Saturday",
      "sector": "SE23 3",
      "district": "SE23"
    },
    "SE239": {
      "day": "Saturday",
      "sector": "SE23 9",
      "district": "SE23"
    },
    "SE240": {
      "day": "Saturday",
      "sector": "SE24 0",
      "district": "SE24"
    },
    "SE244": {
      "day": "Saturday",
      "sector": "SE24 4",
      "district": "SE24"
    },
    "SE249": {
      "day": "Saturday",
      "sector": "SE24 9",
      "district": "SE24"
    },
    "SE254": {
      "day": "Saturday",
      "sector": "SE25 4",
      "district": "SE25"
    },
    "SE255": {
      "day": "Saturday",
      "sector": "SE25 5",
      "district": "SE25"
    },
    "SE256": {
      "day": "Saturday",
      "sector": "SE25 6",
      "district": "SE25"
    },
    "SE259": {
      "day": "Saturday",
      "sector": "SE25 9",
      "district": "SE25"
    },
    "SE264": {
      "day": "Saturday",
      "sector": "SE26 4",
      "district": "SE26"
    },
    "SE265": {
      "day": "Saturday",
      "sector": "SE26 5",
      "district": "SE26"
    },
    "SE266": {
      "day": "Saturday",
      "sector": "SE26 6",
      "district": "SE26"
    },
    "SE269": {
      "day": "Saturday",
      "sector": "SE26 9",
      "district": "SE26"
    },
    "SE270": {
      "day": "Saturday",
      "sector": "SE27 0",
      "district": "SE27"
    },
    "SE277": {
      "day": "Saturday",
      "sector": "SE27 7",
      "district": "SE27"
    },
    "SE279": {
      "day": "Saturday",
      "sector": "SE27 9",
      "district": "SE27"
    },
    "SW21": {
      "day": "Saturday",
      "sector": "SW2 1",
      "district": "SW2"
    },
    "SW22": {
      "day": "Saturday",
      "sector": "SW2 2",
      "district": "SW2"
    },
    "SW23": {
      "day": "Saturday",
      "sector": "SW2 3",
      "district": "SW2"
    },
    "SW24": {
      "day": "Saturday",
      "sector": "SW2 4",
      "district": "SW2"
    },
    "SW25": {
      "day": "Saturday",
      "sector": "SW2 5",
      "district": "SW2"
    },
    "SW29": {
      "day": "Saturday",
      "sector": "SW2 9",
      "district": "SW2"
    },
    "SW90": {
      "day": "Saturday",
      "sector": "SW9 0",
      "district": "SW9"
    },
    "SW91": {
      "day": "Saturday",
      "sector": "SW9 1",
      "district": "SW9"
    },
    "SW96": {
      "day": "Saturday",
      "sector": "SW9 6",
      "district": "SW9"
    },
    "SW97": {
      "day": "Saturday",
      "sector": "SW9 7",
      "district": "SW9"
    },
    "SW98": {
      "day": "Saturday",
      "sector": "SW9 8",
      "district": "SW9"
    },
    "SW99": {
      "day": "Saturday",
      "sector": "SW9 9",
      "district": "SW9"
    },
    "WC1A1": {
      "day": "Saturday",
      "sector": "WC1A 1",
      "district": "WC1A"
    },
    "WC1A2": {
      "day": "Saturday",
      "sector": "WC1A 2",
      "district": "WC1A"
    },
    "WC1A5": {
      "day": "Saturday",
      "sector": "WC1A 5",
      "district": "WC1A"
    },
    "WC1A9": {
      "day": "Saturday",
      "sector": "WC1A 9",
      "district": "WC1A"
    },
    "WC1B3": {
      "day": "Saturday",
      "sector": "WC1B 3",
      "district": "WC1B"
    },
    "WC1B4": {
      "day": "Saturday",
      "sector": "WC1B 4",
      "district": "WC1B"
    },
    "WC1B5": {
      "day": "Saturday",
      "sector": "WC1B 5",
      "district": "WC1B"
    },
    "WC1E6": {
      "day": "Saturday",
      "sector": "WC1E 6",
      "district": "WC1E"
    },
    "WC1E7": {
      "day": "Saturday",
      "sector": "WC1E 7",
      "district": "WC1E"
    },
    "WC1H0": {
      "day": "Saturday",
      "sector": "WC1H 0",
      "district": "WC1H"
    },
    "WC1H8": {
      "day": "Saturday",
      "sector": "WC1H 8",
      "district": "WC1H"
    },
    "WC1H9": {
      "day": "Saturday",
      "sector": "WC1H 9",
      "district": "WC1H"
    },
    "WC1N1": {
      "day": "Saturday",
      "sector": "WC1N 1",
      "district": "WC1N"
    },
    "WC1N2": {
      "day": "Saturday",
      "sector": "WC1N 2",
      "district": "WC1N"
    },
    "WC1N3": {
      "day": "Saturday",
      "sector": "WC1N 3",
      "district": "WC1N"
    },
    "WC1R4": {
      "day": "Saturday",
      "sector": "WC1R 4",
      "district": "WC1R"
    },
    "WC1R5": {
      "day": "Saturday",
      "sector": "WC1R 5",
      "district": "WC1R"
    },
    "WC1V6": {
      "day": "Saturday",
      "sector": "WC1V 6",
      "district": "WC1V"
    },
    "WC1V7": {
      "day": "Saturday",
      "sector": "WC1V 7",
      "district": "WC1V"
    },
    "WC1X0": {
      "day": "Saturday",
      "sector": "WC1X 0",
      "district": "WC1X"
    },
    "WC1X8": {
      "day": "Saturday",
      "sector": "WC1X 8",
      "district": "WC1X"
    },
    "WC1X9": {
      "day": "Saturday",
      "sector": "WC1X 9",
      "district": "WC1X"
    },
    "WC2A1": {
      "day": "Saturday",
      "sector": "WC2A 1",
      "district": "WC2A"
    },
    "WC2A2": {
      "day": "Saturday",
      "sector": "WC2A 2",
      "district": "WC2A"
    },
    "WC2A3": {
      "day": "Saturday",
      "sector": "WC2A 3",
      "district": "WC2A"
    },
    "WC2B4": {
      "day": "Saturday",
      "sector": "WC2B 4",
      "district": "WC2B"
    },
    "WC2B5": {
      "day": "Saturday",
      "sector": "WC2B 5",
      "district": "WC2B"
    },
    "WC2B6": {
      "day": "Saturday",
      "sector": "WC2B 6",
      "district": "WC2B"
    },
    "WC2B8": {
      "day": "Saturday",
      "sector": "WC2B 8",
      "district": "WC2B"
    },
    "WC2E7": {
      "day": "Saturday",
      "sector": "WC2E 7",
      "district": "WC2E"
    },
    "WC2E8": {
      "day": "Saturday",
      "sector": "WC2E 8",
      "district": "WC2E"
    },
    "WC2E9": {
      "day": "Saturday",
      "sector": "WC2E 9",
      "district": "WC2E"
    },
    "WC2H0": {
      "day": "Saturday",
      "sector": "WC2H 0",
      "district": "WC2H"
    },
    "WC2H7": {
      "day": "Saturday",
      "sector": "WC2H 7",
      "district": "WC2H"
    },
    "WC2H8": {
      "day": "Saturday",
      "sector": "WC2H 8",
      "district": "WC2H"
    },
    "WC2H9": {
      "day": "Saturday",
      "sector": "WC2H 9",
      "district": "WC2H"
    },
    "WC2N4": {
      "day": "Saturday",
      "sector": "WC2N 4",
      "district": "WC2N"
    },
    "WC2N5": {
      "day": "Saturday",
      "sector": "WC2N 5",
      "district": "WC2N"
    },
    "WC2N6": {
      "day": "Saturday",
      "sector": "WC2N 6",
      "district": "WC2N"
    },
    "WC2R0": {
      "day": "Saturday",
      "sector": "WC2R 0",
      "district": "WC2R"
    },
    "WC2R1": {
      "day": "Saturday",
      "sector": "WC2R 1",
      "district": "WC2R"
    },
    "WC2R2": {
      "day": "Saturday",
      "sector": "WC2R 2",
      "district": "WC2R"
    },
    "WC2R3": {
      "day": "Saturday",
      "sector": "WC2R 3",
      "district": "WC2R"
    },
    "WC2R4": {
      "day": "Saturday",
      "sector": "WC2R 4",
      "district": "WC2R"
    },
    "CR41": {
      "day": "Sunday",
      "sector": "CR4 1",
      "district": "CR4"
    },
    "CR42": {
      "day": "Sunday",
      "sector": "CR4 2",
      "district": "CR4"
    },
    "CR43": {
      "day": "Sunday",
      "sector": "CR4 3",
      "district": "CR4"
    },
    "CR44": {
      "day": "Sunday",
      "sector": "CR4 4",
      "district": "CR4"
    },
    "CR46": {
      "day": "Sunday",
      "sector": "CR4 6",
      "district": "CR4"
    },
    "CR47": {
      "day": "Sunday",
      "sector": "CR4 7",
      "district": "CR4"
    },
    "CR48": {
      "day": "Sunday",
      "sector": "CR4 8",
      "district": "CR4"
    },
    "CR49": {
      "day": "Sunday",
      "sector": "CR4 9",
      "district": "CR4"
    },
    "CR76": {
      "day": "Sunday",
      "sector": "CR7 6",
      "district": "CR7"
    },
    "KT11": {
      "day": "Sunday",
      "sector": "KT1 1",
      "district": "KT1"
    },
    "KT12": {
      "day": "Sunday",
      "sector": "KT1 2",
      "district": "KT1"
    },
    "KT13": {
      "day": "Sunday",
      "sector": "KT1 3",
      "district": "KT1"
    },
    "KT14": {
      "day": "Sunday",
      "sector": "KT1 4",
      "district": "KT1"
    },
    "KT19": {
      "day": "Sunday",
      "sector": "KT1 9",
      "district": "KT1"
    },
    "KT22": {
      "day": "Sunday",
      "sector": "KT2 2",
      "district": "KT2"
    },
    "KT25": {
      "day": "Sunday",
      "sector": "KT2 5",
      "district": "KT2"
    },
    "KT26": {
      "day": "Sunday",
      "sector": "KT2 6",
      "district": "KT2"
    },
    "KT27": {
      "day": "Sunday",
      "sector": "KT2 7",
      "district": "KT2"
    },
    "KT33": {
      "day": "Sunday",
      "sector": "KT3 3",
      "district": "KT3"
    },
    "KT34": {
      "day": "Sunday",
      "sector": "KT3 4",
      "district": "KT3"
    },
    "KT35": {
      "day": "Sunday",
      "sector": "KT3 5",
      "district": "KT3"
    },
    "KT36": {
      "day": "Sunday",
      "sector": "KT3 6",
      "district": "KT3"
    },
    "KT39": {
      "day": "Sunday",
      "sector": "KT3 9",
      "district": "KT3"
    },
    "NW15": {
      "day": "Sunday",
      "sector": "NW1 5",
      "district": "NW1"
    },
    "NW16": {
      "day": "Sunday",
      "sector": "NW1 6",
      "district": "NW1"
    },
    "NW21": {
      "day": "Sunday",
      "sector": "NW2 1",
      "district": "NW2"
    },
    "NW22": {
      "day": "Sunday",
      "sector": "NW2 2",
      "district": "NW2"
    },
    "NW23": {
      "day": "Sunday",
      "sector": "NW2 3",
      "district": "NW2"
    },
    "NW24": {
      "day": "Sunday",
      "sector": "NW2 4",
      "district": "NW2"
    },
    "NW25": {
      "day": "Sunday",
      "sector": "NW2 5",
      "district": "NW2"
    },
    "NW26": {
      "day": "Sunday",
      "sector": "NW2 6",
      "district": "NW2"
    },
    "NW27": {
      "day": "Sunday",
      "sector": "NW2 7",
      "district": "NW2"
    },
    "NW28": {
      "day": "Sunday",
      "sector": "NW2 8",
      "district": "NW2"
    },
    "NW29": {
      "day": "Sunday",
      "sector": "NW2 9",
      "district": "NW2"
    },
    "NW31": {
      "day": "Sunday",
      "sector": "NW3 1",
      "district": "NW3"
    },
    "NW32": {
      "day": "Sunday",
      "sector": "NW3 2",
      "district": "NW3"
    },
    "NW33": {
      "day": "Sunday",
      "sector": "NW3 3",
      "district": "NW3"
    },
    "NW34": {
      "day": "Sunday",
      "sector": "NW3 4",
      "district": "NW3"
    },
    "NW35": {
      "day": "Sunday",
      "sector": "NW3 5",
      "district": "NW3"
    },
    "NW36": {
      "day": "Sunday",
      "sector": "NW3 6",
      "district": "NW3"
    },
    "NW37": {
      "day": "Sunday",
      "sector": "NW3 7",
      "district": "NW3"
    },
    "NW39": {
      "day": "Sunday",
      "sector": "NW3 9",
      "district": "NW3"
    },
    "NW61": {
      "day": "Sunday",
      "sector": "NW6 1",
      "district": "NW6"
    },
    "NW62": {
      "day": "Sunday",
      "sector": "NW6 2",
      "district": "NW6"
    },
    "NW63": {
      "day": "Sunday",
      "sector": "NW6 3",
      "district": "NW6"
    },
    "NW64": {
      "day": "Sunday",
      "sector": "NW6 4",
      "district": "NW6"
    },
    "NW65": {
      "day": "Sunday",
      "sector": "NW6 5",
      "district": "NW6"
    },
    "NW66": {
      "day": "Sunday",
      "sector": "NW6 6",
      "district": "NW6"
    },
    "NW67": {
      "day": "Sunday",
      "sector": "NW6 7",
      "district": "NW6"
    },
    "NW69": {
      "day": "Sunday",
      "sector": "NW6 9",
      "district": "NW6"
    },
    "NW80": {
      "day": "Sunday",
      "sector": "NW8 0",
      "district": "NW8"
    },
    "NW81": {
      "day": "Sunday",
      "sector": "NW8 1",
      "district": "NW8"
    },
    "NW86": {
      "day": "Sunday",
      "sector": "NW8 6",
      "district": "NW8"
    },
    "NW87": {
      "day": "Sunday",
      "sector": "NW8 7",
      "district": "NW8"
    },
    "NW88": {
      "day": "Sunday",
      "sector": "NW8 8",
      "district": "NW8"
    },
    "NW89": {
      "day": "Sunday",
      "sector": "NW8 9",
      "district": "NW8"
    },
    "NW101": {
      "day": "Sunday",
      "sector": "NW10 1",
      "district": "NW10"
    },
    "NW102": {
      "day": "Sunday",
      "sector": "NW10 2",
      "district": "NW10"
    },
    "NW103": {
      "day": "Sunday",
      "sector": "NW10 3",
      "district": "NW10"
    },
    "NW104": {
      "day": "Sunday",
      "sector": "NW10 4",
      "district": "NW10"
    },
    "NW105": {
      "day": "Sunday",
      "sector": "NW10 5",
      "district": "NW10"
    },
    "NW106": {
      "day": "Sunday",
      "sector": "NW10 6",
      "district": "NW10"
    },
    "NW109": {
      "day": "Sunday",
      "sector": "NW10 9",
      "district": "NW10"
    },
    "NW110": {
      "day": "Sunday",
      "sector": "NW11 0",
      "district": "NW11"
    },
    "NW111": {
      "day": "Sunday",
      "sector": "NW11 1",
      "district": "NW11"
    },
    "NW116": {
      "day": "Sunday",
      "sector": "NW11 6",
      "district": "NW11"
    },
    "NW117": {
      "day": "Sunday",
      "sector": "NW11 7",
      "district": "NW11"
    },
    "NW118": {
      "day": "Sunday",
      "sector": "NW11 8",
      "district": "NW11"
    },
    "NW119": {
      "day": "Sunday",
      "sector": "NW11 9",
      "district": "NW11"
    },
    "SM44": {
      "day": "Sunday",
      "sector": "SM4 4",
      "district": "SM4"
    },
    "SM45": {
      "day": "Sunday",
      "sector": "SM4 5",
      "district": "SM4"
    },
    "SM46": {
      "day": "Sunday",
      "sector": "SM4 6",
      "district": "SM4"
    },
    "SM49": {
      "day": "Sunday",
      "sector": "SM4 9",
      "district": "SM4"
    },
    "SW1A0": {
      "day": "Sunday",
      "sector": "SW1A 0",
      "district": "SW1A"
    },
    "SW1A1": {
      "day": "Sunday",
      "sector": "SW1A 1",
      "district": "SW1A"
    },
    "SW1A2": {
      "day": "Sunday",
      "sector": "SW1A 2",
      "district": "SW1A"
    },
    "SW1E5": {
      "day": "Sunday",
      "sector": "SW1E 5",
      "district": "SW1E"
    },
    "SW1E6": {
      "day": "Sunday",
      "sector": "SW1E 6",
      "district": "SW1E"
    },
    "SW1H0": {
      "day": "Sunday",
      "sector": "SW1H 0",
      "district": "SW1H"
    },
    "SW1H9": {
      "day": "Sunday",
      "sector": "SW1H 9",
      "district": "SW1H"
    },
    "SW1P1": {
      "day": "Sunday",
      "sector": "SW1P 1",
      "district": "SW1P"
    },
    "SW1P2": {
      "day": "Sunday",
      "sector": "SW1P 2",
      "district": "SW1P"
    },
    "SW1P3": {
      "day": "Sunday",
      "sector": "SW1P 3",
      "district": "SW1P"
    },
    "SW1P4": {
      "day": "Sunday",
      "sector": "SW1P 4",
      "district": "SW1P"
    },
    "SW1P9": {
      "day": "Sunday",
      "sector": "SW1P 9",
      "district": "SW1P"
    },
    "SW1V1": {
      "day": "Sunday",
      "sector": "SW1V 1",
      "district": "SW1V"
    },
    "SW1V2": {
      "day": "Sunday",
      "sector": "SW1V 2",
      "district": "SW1V"
    },
    "SW1V3": {
      "day": "Sunday",
      "sector": "SW1V 3",
      "district": "SW1V"
    },
    "SW1V4": {
      "day": "Sunday",
      "sector": "SW1V 4",
      "district": "SW1V"
    },
    "SW1W0": {
      "day": "Sunday",
      "sector": "SW1W 0",
      "district": "SW1W"
    },
    "SW1W8": {
      "day": "Sunday",
      "sector": "SW1W 8",
      "district": "SW1W"
    },
    "SW1W9": {
      "day": "Sunday",
      "sector": "SW1W 9",
      "district": "SW1W"
    },
    "SW1X0": {
      "day": "Sunday",
      "sector": "SW1X 0",
      "district": "SW1X"
    },
    "SW1X1": {
      "day": "Sunday",
      "sector": "SW1X 1",
      "district": "SW1X"
    },
    "SW1X7": {
      "day": "Sunday",
      "sector": "SW1X 7",
      "district": "SW1X"
    },
    "SW1X8": {
      "day": "Sunday",
      "sector": "SW1X 8",
      "district": "SW1X"
    },
    "SW1X9": {
      "day": "Sunday",
      "sector": "SW1X 9",
      "district": "SW1X"
    },
    "SW1Y4": {
      "day": "Sunday",
      "sector": "SW1Y 4",
      "district": "SW1Y"
    },
    "SW1Y5": {
      "day": "Sunday",
      "sector": "SW1Y 5",
      "district": "SW1Y"
    },
    "SW1Y6": {
      "day": "Sunday",
      "sector": "SW1Y 6",
      "district": "SW1Y"
    },
    "SW31": {
      "day": "Sunday",
      "sector": "SW3 1",
      "district": "SW3"
    },
    "SW32": {
      "day": "Sunday",
      "sector": "SW3 2",
      "district": "SW3"
    },
    "SW33": {
      "day": "Sunday",
      "sector": "SW3 3",
      "district": "SW3"
    },
    "SW34": {
      "day": "Sunday",
      "sector": "SW3 4",
      "district": "SW3"
    },
    "SW35": {
      "day": "Sunday",
      "sector": "SW3 5",
      "district": "SW3"
    },
    "SW36": {
      "day": "Sunday",
      "sector": "SW3 6",
      "district": "SW3"
    },
    "SW39": {
      "day": "Sunday",
      "sector": "SW3 9",
      "district": "SW3"
    },
    "SW40": {
      "day": "Sunday",
      "sector": "SW4 0",
      "district": "SW4"
    },
    "SW44": {
      "day": "Sunday",
      "sector": "SW4 4",
      "district": "SW4"
    },
    "SW46": {
      "day": "Sunday",
      "sector": "SW4 6",
      "district": "SW4"
    },
    "SW47": {
      "day": "Sunday",
      "sector": "SW4 7",
      "district": "SW4"
    },
    "SW48": {
      "day": "Sunday",
      "sector": "SW4 8",
      "district": "SW4"
    },
    "SW49": {
      "day": "Sunday",
      "sector": "SW4 9",
      "district": "SW4"
    },
    "SW50": {
      "day": "Sunday",
      "sector": "SW5 0",
      "district": "SW5"
    },
    "SW55": {
      "day": "Sunday",
      "sector": "SW5 5",
      "district": "SW5"
    },
    "SW59": {
      "day": "Sunday",
      "sector": "SW5 9",
      "district": "SW5"
    },
    "SW61": {
      "day": "Sunday",
      "sector": "SW6 1",
      "district": "SW6"
    },
    "SW62": {
      "day": "Sunday",
      "sector": "SW6 2",
      "district": "SW6"
    },
    "SW63": {
      "day": "Sunday",
      "sector": "SW6 3",
      "district": "SW6"
    },
    "SW64": {
      "day": "Sunday",
      "sector": "SW6 4",
      "district": "SW6"
    },
    "SW65": {
      "day": "Sunday",
      "sector": "SW6 5",
      "district": "SW6"
    },
    "SW66": {
      "day": "Sunday",
      "sector": "SW6 6",
      "district": "SW6"
    },
    "SW67": {
      "day": "Sunday",
      "sector": "SW6 7",
      "district": "SW6"
    },
    "SW69": {
      "day": "Sunday",
      "sector": "SW6 9",
      "district": "SW6"
    },
    "SW71": {
      "day": "Sunday",
      "sector": "SW7 1",
      "district": "SW7"
    },
    "SW72": {
      "day": "Sunday",
      "sector": "SW7 2",
      "district": "SW7"
    },
    "SW73": {
      "day": "Sunday",
      "sector": "SW7 3",
      "district": "SW7"
    },
    "SW74": {
      "day": "Sunday",
      "sector": "SW7 4",
      "district": "SW7"
    },
    "SW75": {
      "day": "Sunday",
      "sector": "SW7 5",
      "district": "SW7"
    },
    "SW77": {
      "day": "Sunday",
      "sector": "SW7 7",
      "district": "SW7"
    },
    "SW79": {
      "day": "Sunday",
      "sector": "SW7 9",
      "district": "SW7"
    },
    "SW81": {
      "day": "Sunday",
      "sector": "SW8 1",
      "district": "SW8"
    },
    "SW82": {
      "day": "Sunday",
      "sector": "SW8 2",
      "district": "SW8"
    },
    "SW83": {
      "day": "Sunday",
      "sector": "SW8 3",
      "district": "SW8"
    },
    "SW84": {
      "day": "Sunday",
      "sector": "SW8 4",
      "district": "SW8"
    },
    "SW85": {
      "day": "Sunday",
      "sector": "SW8 5",
      "district": "SW8"
    },
    "SW89": {
      "day": "Sunday",
      "sector": "SW8 9",
      "district": "SW8"
    },
    "SW100": {
      "day": "Sunday",
      "sector": "SW10 0",
      "district": "SW10"
    },
    "SW101": {
      "day": "Sunday",
      "sector": "SW10 1",
      "district": "SW10"
    },
    "SW109": {
      "day": "Sunday",
      "sector": "SW10 9",
      "district": "SW10"
    },
    "SW111": {
      "day": "Sunday",
      "sector": "SW11 1",
      "district": "SW11"
    },
    "SW112": {
      "day": "Sunday",
      "sector": "SW11 2",
      "district": "SW11"
    },
    "SW113": {
      "day": "Sunday",
      "sector": "SW11 3",
      "district": "SW11"
    },
    "SW114": {
      "day": "Sunday",
      "sector": "SW11 4",
      "district": "SW11"
    },
    "SW115": {
      "day": "Sunday",
      "sector": "SW11 5",
      "district": "SW11"
    },
    "SW116": {
      "day": "Sunday",
      "sector": "SW11 6",
      "district": "SW11"
    },
    "SW117": {
      "day": "Sunday",
      "sector": "SW11 7",
      "district": "SW11"
    },
    "SW118": {
      "day": "Sunday",
      "sector": "SW11 8",
      "district": "SW11"
    },
    "SW119": {
      "day": "Sunday",
      "sector": "SW11 9",
      "district": "SW11"
    },
    "SW120": {
      "day": "Sunday",
      "sector": "SW12 0",
      "district": "SW12"
    },
    "SW122": {
      "day": "Sunday",
      "sector": "SW12 2",
      "district": "SW12"
    },
    "SW128": {
      "day": "Sunday",
      "sector": "SW12 8",
      "district": "SW12"
    },
    "SW129": {
      "day": "Sunday",
      "sector": "SW12 9",
      "district": "SW12"
    },
    "SW130": {
      "day": "Sunday",
      "sector": "SW13 0",
      "district": "SW13"
    },
    "SW131": {
      "day": "Sunday",
      "sector": "SW13 1",
      "district": "SW13"
    },
    "SW133": {
      "day": "Sunday",
      "sector": "SW13 3",
      "district": "SW13"
    },
    "SW138": {
      "day": "Sunday",
      "sector": "SW13 8",
      "district": "SW13"
    },
    "SW139": {
      "day": "Sunday",
      "sector": "SW13 9",
      "district": "SW13"
    },
    "SW147": {
      "day": "Sunday",
      "sector": "SW14 7",
      "district": "SW14"
    },
    "SW148": {
      "day": "Sunday",
      "sector": "SW14 8",
      "district": "SW14"
    },
    "SW149": {
      "day": "Sunday",
      "sector": "SW14 9",
      "district": "SW14"
    },
    "SW151": {
      "day": "Sunday",
      "sector": "SW15 1",
      "district": "SW15"
    },
    "SW152": {
      "day": "Sunday",
      "sector": "SW15 2",
      "district": "SW15"
    },
    "SW153": {
      "day": "Sunday",
      "sector": "SW15 3",
      "district": "SW15"
    },
    "SW154": {
      "day": "Sunday",
      "sector": "SW15 4",
      "district": "SW15"
    },
    "SW155": {
      "day": "Sunday",
      "sector": "SW15 5",
      "district": "SW15"
    },
    "SW156": {
      "day": "Sunday",
      "sector": "SW15 6",
      "district": "SW15"
    },
    "SW159": {
      "day": "Sunday",
      "sector": "SW15 9",
      "district": "SW15"
    },
    "SW161": {
      "day": "Sunday",
      "sector": "SW16 1",
      "district": "SW16"
    },
    "SW162": {
      "day": "Sunday",
      "sector": "SW16 2",
      "district": "SW16"
    },
    "SW163": {
      "day": "Sunday",
      "sector": "SW16 3",
      "district": "SW16"
    },
    "SW164": {
      "day": "Sunday",
      "sector": "SW16 4",
      "district": "SW16"
    },
    "SW165": {
      "day": "Sunday",
      "sector": "SW16 5",
      "district": "SW16"
    },
    "SW166": {
      "day": "Sunday",
      "sector": "SW16 6",
      "district": "SW16"
    },
    "SW169": {
      "day": "Sunday",
      "sector": "SW16 9",
      "district": "SW16"
    },
    "SW170": {
      "day": "Sunday",
      "sector": "SW17 0",
      "district": "SW17"
    },
    "SW171": {
      "day": "Sunday",
      "sector": "SW17 1",
      "district": "SW17"
    },
    "SW176": {
      "day": "Sunday",
      "sector": "SW17 6",
      "district": "SW17"
    },
    "SW177": {
      "day": "Sunday",
      "sector": "SW17 7",
      "district": "SW17"
    },
    "SW178": {
      "day": "Sunday",
      "sector": "SW17 8",
      "district": "SW17"
    },
    "SW179": {
      "day": "Sunday",
      "sector": "SW17 9",
      "district": "SW17"
    },
    "SW181": {
      "day": "Sunday",
      "sector": "SW18 1",
      "district": "SW18"
    },
    "SW182": {
      "day": "Sunday",
      "sector": "SW18 2",
      "district": "SW18"
    },
    "SW183": {
      "day": "Sunday",
      "sector": "SW18 3",
      "district": "SW18"
    },
    "SW184": {
      "day": "Sunday",
      "sector": "SW18 4",
      "district": "SW18"
    },
    "SW185": {
      "day": "Sunday",
      "sector": "SW18 5",
      "district": "SW18"
    },
    "SW189": {
      "day": "Sunday",
      "sector": "SW18 9",
      "district": "SW18"
    },
    "SW191": {
      "day": "Sunday",
      "sector": "SW19 1",
      "district": "SW19"
    },
    "SW192": {
      "day": "Sunday",
      "sector": "SW19 2",
      "district": "SW19"
    },
    "SW193": {
      "day": "Sunday",
      "sector": "SW19 3",
      "district": "SW19"
    },
    "SW194": {
      "day": "Sunday",
      "sector": "SW19 4",
      "district": "SW19"
    },
    "SW195": {
      "day": "Sunday",
      "sector": "SW19 5",
      "district": "SW19"
    },
    "SW196": {
      "day": "Sunday",
      "sector": "SW19 6",
      "district": "SW19"
    },
    "SW197": {
      "day": "Sunday",
      "sector": "SW19 7",
      "district": "SW19"
    },
    "SW198": {
      "day": "Sunday",
      "sector": "SW19 8",
      "district": "SW19"
    },
    "SW199": {
      "day": "Sunday",
      "sector": "SW19 9",
      "district": "SW19"
    },
    "SW200": {
      "day": "Sunday",
      "sector": "SW20 0",
      "district": "SW20"
    },
    "SW202": {
      "day": "Sunday",
      "sector": "SW20 2",
      "district": "SW20"
    },
    "SW208": {
      "day": "Sunday",
      "sector": "SW20 8",
      "district": "SW20"
    },
    "SW209": {
      "day": "Sunday",
      "sector": "SW20 9",
      "district": "SW20"
    },
    "TW80": {
      "day": "Sunday",
      "sector": "TW8 0",
      "district": "TW8"
    },
    "TW81": {
      "day": "Sunday",
      "sector": "TW8 1",
      "district": "TW8"
    },
    "TW88": {
      "day": "Sunday",
      "sector": "TW8 8",
      "district": "TW8"
    },
    "TW89": {
      "day": "Sunday",
      "sector": "TW8 9",
      "district": "TW8"
    },
    "TW91": {
      "day": "Sunday",
      "sector": "TW9 1",
      "district": "TW9"
    },
    "TW92": {
      "day": "Sunday",
      "sector": "TW9 2",
      "district": "TW9"
    },
    "TW93": {
      "day": "Sunday",
      "sector": "TW9 3",
      "district": "TW9"
    },
    "TW94": {
      "day": "Sunday",
      "sector": "TW9 4",
      "district": "TW9"
    },
    "TW99": {
      "day": "Sunday",
      "sector": "TW9 9",
      "district": "TW9"
    },
    "TW103": {
      "day": "Sunday",
      "sector": "TW10 3",
      "district": "TW10"
    },
    "TW105": {
      "day": "Sunday",
      "sector": "TW10 5",
      "district": "TW10"
    },
    "TW106": {
      "day": "Sunday",
      "sector": "TW10 6",
      "district": "TW10"
    },
    "TW107": {
      "day": "Sunday",
      "sector": "TW10 7",
      "district": "TW10"
    },
    "W13": {
      "day": "Sunday",
      "sector": "W1 3",
      "district": "W1"
    },
    "W1A0": {
      "day": "Sunday",
      "sector": "W1A 0",
      "district": "W1A"
    },
    "W1A1": {
      "day": "Sunday",
      "sector": "W1A 1",
      "district": "W1A"
    },
    "W1A2": {
      "day": "Sunday",
      "sector": "W1A 2",
      "district": "W1A"
    },
    "W1A3": {
      "day": "Sunday",
      "sector": "W1A 3",
      "district": "W1A"
    },
    "W1A4": {
      "day": "Sunday",
      "sector": "W1A 4",
      "district": "W1A"
    },
    "W1A5": {
      "day": "Sunday",
      "sector": "W1A 5",
      "district": "W1A"
    },
    "W1A6": {
      "day": "Sunday",
      "sector": "W1A 6",
      "district": "W1A"
    },
    "W1A7": {
      "day": "Sunday",
      "sector": "W1A 7",
      "district": "W1A"
    },
    "W1A8": {
      "day": "Sunday",
      "sector": "W1A 8",
      "district": "W1A"
    },
    "W1A9": {
      "day": "Sunday",
      "sector": "W1A 9",
      "district": "W1A"
    },
    "W1B1": {
      "day": "Sunday",
      "sector": "W1B 1",
      "district": "W1B"
    },
    "W1B2": {
      "day": "Sunday",
      "sector": "W1B 2",
      "district": "W1B"
    },
    "W1B3": {
      "day": "Sunday",
      "sector": "W1B 3",
      "district": "W1B"
    },
    "W1B4": {
      "day": "Sunday",
      "sector": "W1B 4",
      "district": "W1B"
    },
    "W1B5": {
      "day": "Sunday",
      "sector": "W1B 5",
      "district": "W1B"
    },
    "W1C1": {
      "day": "Sunday",
      "sector": "W1C 1",
      "district": "W1C"
    },
    "W1C2": {
      "day": "Sunday",
      "sector": "W1C 2",
      "district": "W1C"
    },
    "W1D1": {
      "day": "Sunday",
      "sector": "W1D 1",
      "district": "W1D"
    },
    "W1D2": {
      "day": "Sunday",
      "sector": "W1D 2",
      "district": "W1D"
    },
    "W1D3": {
      "day": "Sunday",
      "sector": "W1D 3",
      "district": "W1D"
    },
    "W1D4": {
      "day": "Sunday",
      "sector": "W1D 4",
      "district": "W1D"
    },
    "W1D5": {
      "day": "Sunday",
      "sector": "W1D 5",
      "district": "W1D"
    },
    "W1D6": {
      "day": "Sunday",
      "sector": "W1D 6",
      "district": "W1D"
    },
    "W1D7": {
      "day": "Sunday",
      "sector": "W1D 7",
      "district": "W1D"
    },
    "W1E5": {
      "day": "Sunday",
      "sector": "W1E 5",
      "district": "W1E"
    },
    "W1F0": {
      "day": "Sunday",
      "sector": "W1F 0",
      "district": "W1F"
    },
    "W1F7": {
      "day": "Sunday",
      "sector": "W1F 7",
      "district": "W1F"
    },
    "W1F8": {
      "day": "Sunday",
      "sector": "W1F 8",
      "district": "W1F"
    },
    "W1F9": {
      "day": "Sunday",
      "sector": "W1F 9",
      "district": "W1F"
    },
    "W1G0": {
      "day": "Sunday",
      "sector": "W1G 0",
      "district": "W1G"
    },
    "W1G6": {
      "day": "Sunday",
      "sector": "W1G 6",
      "district": "W1G"
    },
    "W1G7": {
      "day": "Sunday",
      "sector": "W1G 7",
      "district": "W1G"
    },
    "W1G8": {
      "day": "Sunday",
      "sector": "W1G 8",
      "district": "W1G"
    },
    "W1G9": {
      "day": "Sunday",
      "sector": "W1G 9",
      "district": "W1G"
    },
    "W1H0": {
      "day": "Sunday",
      "sector": "W1H 0",
      "district": "W1H"
    },
    "W1H1": {
      "day": "Sunday",
      "sector": "W1H 1",
      "district": "W1H"
    },
    "W1H2": {
      "day": "Sunday",
      "sector": "W1H 2",
      "district": "W1H"
    },
    "W1H3": {
      "day": "Sunday",
      "sector": "W1H 3",
      "district": "W1H"
    },
    "W1H4": {
      "day": "Sunday",
      "sector": "W1H 4",
      "district": "W1H"
    },
    "W1H5": {
      "day": "Sunday",
      "sector": "W1H 5",
      "district": "W1H"
    },
    "W1H6": {
      "day": "Sunday",
      "sector": "W1H 6",
      "district": "W1H"
    },
    "W1H7": {
      "day": "Sunday",
      "sector": "W1H 7",
      "district": "W1H"
    },
    "W1H8": {
      "day": "Sunday",
      "sector": "W1H 8",
      "district": "W1H"
    },
    "W1H9": {
      "day": "Sunday",
      "sector": "W1H 9",
      "district": "W1H"
    },
    "W1J0": {
      "day": "Sunday",
      "sector": "W1J 0",
      "district": "W1J"
    },
    "W1J5": {
      "day": "Sunday",
      "sector": "W1J 5",
      "district": "W1J"
    },
    "W1J6": {
      "day": "Sunday",
      "sector": "W1J 6",
      "district": "W1J"
    },
    "W1J7": {
      "day": "Sunday",
      "sector": "W1J 7",
      "district": "W1J"
    },
    "W1J8": {
      "day": "Sunday",
      "sector": "W1J 8",
      "district": "W1J"
    },
    "W1J9": {
      "day": "Sunday",
      "sector": "W1J 9",
      "district": "W1J"
    },
    "W1K1": {
      "day": "Sunday",
      "sector": "W1K 1",
      "district": "W1K"
    },
    "W1K2": {
      "day": "Sunday",
      "sector": "W1K 2",
      "district": "W1K"
    },
    "W1K3": {
      "day": "Sunday",
      "sector": "W1K 3",
      "district": "W1K"
    },
    "W1K4": {
      "day": "Sunday",
      "sector": "W1K 4",
      "district": "W1K"
    },
    "W1K5": {
      "day": "Sunday",
      "sector": "W1K 5",
      "district": "W1K"
    },
    "W1K6": {
      "day": "Sunday",
      "sector": "W1K 6",
      "district": "W1K"
    },
    "W1K7": {
      "day": "Sunday",
      "sector": "W1K 7",
      "district": "W1K"
    },
    "W1M0": {
      "day": "Sunday",
      "sector": "W1M 0",
      "district": "W1M"
    },
    "W1M1": {
      "day": "Sunday",
      "sector": "W1M 1",
      "district": "W1M"
    },
    "W1M2": {
      "day": "Sunday",
      "sector": "W1M 2",
      "district": "W1M"
    },
    "W1M3": {
      "day": "Sunday",
      "sector": "W1M 3",
      "district": "W1M"
    },
    "W1M4": {
      "day": "Sunday",
      "sector": "W1M 4",
      "district": "W1M"
    },
    "W1M5": {
      "day": "Sunday",
      "sector": "W1M 5",
      "district": "W1M"
    },
    "W1M6": {
      "day": "Sunday",
      "sector": "W1M 6",
      "district": "W1M"
    },
    "W1M7": {
      "day": "Sunday",
      "sector": "W1M 7",
      "district": "W1M"
    },
    "W1M8": {
      "day": "Sunday",
      "sector": "W1M 8",
      "district": "W1M"
    },
    "W1M9": {
      "day": "Sunday",
      "sector": "W1M 9",
      "district": "W1M"
    },
    "W1N0": {
      "day": "Sunday",
      "sector": "W1N 0",
      "district": "W1N"
    },
    "W1N1": {
      "day": "Sunday",
      "sector": "W1N 1",
      "district": "W1N"
    },
    "W1N2": {
      "day": "Sunday",
      "sector": "W1N 2",
      "district": "W1N"
    },
    "W1N3": {
      "day": "Sunday",
      "sector": "W1N 3",
      "district": "W1N"
    },
    "W1N4": {
      "day": "Sunday",
      "sector": "W1N 4",
      "district": "W1N"
    },
    "W1N5": {
      "day": "Sunday",
      "sector": "W1N 5",
      "district": "W1N"
    },
    "W1N6": {
      "day": "Sunday",
      "sector": "W1N 6",
      "district": "W1N"
    },
    "W1N7": {
      "day": "Sunday",
      "sector": "W1N 7",
      "district": "W1N"
    },
    "W1N8": {
      "day": "Sunday",
      "sector": "W1N 8",
      "district": "W1N"
    },
    "W1N9": {
      "day": "Sunday",
      "sector": "W1N 9",
      "district": "W1N"
    },
    "W1P0": {
      "day": "Sunday",
      "sector": "W1P 0",
      "district": "W1P"
    },
    "W1P1": {
      "day": "Sunday",
      "sector": "W1P 1",
      "district": "W1P"
    },
    "W1P2": {
      "day": "Sunday",
      "sector": "W1P 2",
      "district": "W1P"
    },
    "W1P3": {
      "day": "Sunday",
      "sector": "W1P 3",
      "district": "W1P"
    },
    "W1P4": {
      "day": "Sunday",
      "sector": "W1P 4",
      "district": "W1P"
    },
    "W1P5": {
      "day": "Sunday",
      "sector": "W1P 5",
      "district": "W1P"
    },
    "W1P6": {
      "day": "Sunday",
      "sector": "W1P 6",
      "district": "W1P"
    },
    "W1P7": {
      "day": "Sunday",
      "sector": "W1P 7",
      "district": "W1P"
    },
    "W1P8": {
      "day": "Sunday",
      "sector": "W1P 8",
      "district": "W1P"
    },
    "W1P9": {
      "day": "Sunday",
      "sector": "W1P 9",
      "district": "W1P"
    },
    "W1R0": {
      "day": "Sunday",
      "sector": "W1R 0",
      "district": "W1R"
    },
    "W1R1": {
      "day": "Sunday",
      "sector": "W1R 1",
      "district": "W1R"
    },
    "W1R2": {
      "day": "Sunday",
      "sector": "W1R 2",
      "district": "W1R"
    },
    "W1R3": {
      "day": "Sunday",
      "sector": "W1R 3",
      "district": "W1R"
    },
    "W1R4": {
      "day": "Sunday",
      "sector": "W1R 4",
      "district": "W1R"
    },
    "W1R5": {
      "day": "Sunday",
      "sector": "W1R 5",
      "district": "W1R"
    },
    "W1R6": {
      "day": "Sunday",
      "sector": "W1R 6",
      "district": "W1R"
    },
    "W1R7": {
      "day": "Sunday",
      "sector": "W1R 7",
      "district": "W1R"
    },
    "W1R8": {
      "day": "Sunday",
      "sector": "W1R 8",
      "district": "W1R"
    },
    "W1R9": {
      "day": "Sunday",
      "sector": "W1R 9",
      "district": "W1R"
    },
    "W1S1": {
      "day": "Sunday",
      "sector": "W1S 1",
      "district": "W1S"
    },
    "W1S2": {
      "day": "Sunday",
      "sector": "W1S 2",
      "district": "W1S"
    },
    "W1S3": {
      "day": "Sunday",
      "sector": "W1S 3",
      "district": "W1S"
    },
    "W1S4": {
      "day": "Sunday",
      "sector": "W1S 4",
      "district": "W1S"
    },
    "W1T1": {
      "day": "Sunday",
      "sector": "W1T 1",
      "district": "W1T"
    },
    "W1T2": {
      "day": "Sunday",
      "sector": "W1T 2",
      "district": "W1T"
    },
    "W1T3": {
      "day": "Sunday",
      "sector": "W1T 3",
      "district": "W1T"
    },
    "W1T4": {
      "day": "Sunday",
      "sector": "W1T 4",
      "district": "W1T"
    },
    "W1T5": {
      "day": "Sunday",
      "sector": "W1T 5",
      "district": "W1T"
    },
    "W1T6": {
      "day": "Sunday",
      "sector": "W1T 6",
      "district": "W1T"
    },
    "W1T7": {
      "day": "Sunday",
      "sector": "W1T 7",
      "district": "W1T"
    },
    "W1U1": {
      "day": "Sunday",
      "sector": "W1U 1",
      "district": "W1U"
    },
    "W1U2": {
      "day": "Sunday",
      "sector": "W1U 2",
      "district": "W1U"
    },
    "W1U3": {
      "day": "Sunday",
      "sector": "W1U 3",
      "district": "W1U"
    },
    "W1U4": {
      "day": "Sunday",
      "sector": "W1U 4",
      "district": "W1U"
    },
    "W1U5": {
      "day": "Sunday",
      "sector": "W1U 5",
      "district": "W1U"
    },
    "W1U6": {
      "day": "Sunday",
      "sector": "W1U 6",
      "district": "W1U"
    },
    "W1U7": {
      "day": "Sunday",
      "sector": "W1U 7",
      "district": "W1U"
    },
    "W1U8": {
      "day": "Sunday",
      "sector": "W1U 8",
      "district": "W1U"
    },
    "W1V0": {
      "day": "Sunday",
      "sector": "W1V 0",
      "district": "W1V"
    },
    "W1V1": {
      "day": "Sunday",
      "sector": "W1V 1",
      "district": "W1V"
    },
    "W1V2": {
      "day": "Sunday",
      "sector": "W1V 2",
      "district": "W1V"
    },
    "W1V3": {
      "day": "Sunday",
      "sector": "W1V 3",
      "district": "W1V"
    },
    "W1V4": {
      "day": "Sunday",
      "sector": "W1V 4",
      "district": "W1V"
    },
    "W1V5": {
      "day": "Sunday",
      "sector": "W1V 5",
      "district": "W1V"
    },
    "W1V6": {
      "day": "Sunday",
      "sector": "W1V 6",
      "district": "W1V"
    },
    "W1V7": {
      "day": "Sunday",
      "sector": "W1V 7",
      "district": "W1V"
    },
    "W1V8": {
      "day": "Sunday",
      "sector": "W1V 8",
      "district": "W1V"
    },
    "W1V9": {
      "day": "Sunday",
      "sector": "W1V 9",
      "district": "W1V"
    },
    "W1W5": {
      "day": "Sunday",
      "sector": "W1W 5",
      "district": "W1W"
    },
    "W1W6": {
      "day": "Sunday",
      "sector": "W1W 6",
      "district": "W1W"
    },
    "W1W7": {
      "day": "Sunday",
      "sector": "W1W 7",
      "district": "W1W"
    },
    "W1W8": {
      "day": "Sunday",
      "sector": "W1W 8",
      "district": "W1W"
    },
    "W1X0": {
      "day": "Sunday",
      "sector": "W1X 0",
      "district": "W1X"
    },
    "W1X1": {
      "day": "Sunday",
      "sector": "W1X 1",
      "district": "W1X"
    },
    "W1X2": {
      "day": "Sunday",
      "sector": "W1X 2",
      "district": "W1X"
    },
    "W1X3": {
      "day": "Sunday",
      "sector": "W1X 3",
      "district": "W1X"
    },
    "W1X4": {
      "day": "Sunday",
      "sector": "W1X 4",
      "district": "W1X"
    },
    "W1X5": {
      "day": "Sunday",
      "sector": "W1X 5",
      "district": "W1X"
    },
    "W1X6": {
      "day": "Sunday",
      "sector": "W1X 6",
      "district": "W1X"
    },
    "W1X7": {
      "day": "Sunday",
      "sector": "W1X 7",
      "district": "W1X"
    },
    "W1X8": {
      "day": "Sunday",
      "sector": "W1X 8",
      "district": "W1X"
    },
    "W1X9": {
      "day": "Sunday",
      "sector": "W1X 9",
      "district": "W1X"
    },
    "W1Y0": {
      "day": "Sunday",
      "sector": "W1Y 0",
      "district": "W1Y"
    },
    "W1Y1": {
      "day": "Sunday",
      "sector": "W1Y 1",
      "district": "W1Y"
    },
    "W1Y2": {
      "day": "Sunday",
      "sector": "W1Y 2",
      "district": "W1Y"
    },
    "W1Y3": {
      "day": "Sunday",
      "sector": "W1Y 3",
      "district": "W1Y"
    },
    "W1Y4": {
      "day": "Sunday",
      "sector": "W1Y 4",
      "district": "W1Y"
    },
    "W1Y5": {
      "day": "Sunday",
      "sector": "W1Y 5",
      "district": "W1Y"
    },
    "W1Y6": {
      "day": "Sunday",
      "sector": "W1Y 6",
      "district": "W1Y"
    },
    "W1Y7": {
      "day": "Sunday",
      "sector": "W1Y 7",
      "district": "W1Y"
    },
    "W1Y8": {
      "day": "Sunday",
      "sector": "W1Y 8",
      "district": "W1Y"
    },
    "W1Y9": {
      "day": "Sunday",
      "sector": "W1Y 9",
      "district": "W1Y"
    },
    "W21": {
      "day": "Sunday",
      "sector": "W2 1",
      "district": "W2"
    },
    "W22": {
      "day": "Sunday",
      "sector": "W2 2",
      "district": "W2"
    },
    "W23": {
      "day": "Sunday",
      "sector": "W2 3",
      "district": "W2"
    },
    "W24": {
      "day": "Sunday",
      "sector": "W2 4",
      "district": "W2"
    },
    "W25": {
      "day": "Sunday",
      "sector": "W2 5",
      "district": "W2"
    },
    "W26": {
      "day": "Sunday",
      "sector": "W2 6",
      "district": "W2"
    },
    "W27": {
      "day": "Sunday",
      "sector": "W2 7",
      "district": "W2"
    },
    "W30": {
      "day": "Sunday",
      "sector": "W3 0",
      "district": "W3"
    },
    "W33": {
      "day": "Sunday",
      "sector": "W3 3",
      "district": "W3"
    },
    "W36": {
      "day": "Sunday",
      "sector": "W3 6",
      "district": "W3"
    },
    "W37": {
      "day": "Sunday",
      "sector": "W3 7",
      "district": "W3"
    },
    "W38": {
      "day": "Sunday",
      "sector": "W3 8",
      "district": "W3"
    },
    "W39": {
      "day": "Sunday",
      "sector": "W3 9",
      "district": "W3"
    },
    "W41": {
      "day": "Sunday",
      "sector": "W4 1",
      "district": "W4"
    },
    "W42": {
      "day": "Sunday",
      "sector": "W4 2",
      "district": "W4"
    },
    "W43": {
      "day": "Sunday",
      "sector": "W4 3",
      "district": "W4"
    },
    "W44": {
      "day": "Sunday",
      "sector": "W4 4",
      "district": "W4"
    },
    "W45": {
      "day": "Sunday",
      "sector": "W4 5",
      "district": "W4"
    },
    "W49": {
      "day": "Sunday",
      "sector": "W4 9",
      "district": "W4"
    },
    "W51": {
      "day": "Sunday",
      "sector": "W5 1",
      "district": "W5"
    },
    "W52": {
      "day": "Sunday",
      "sector": "W5 2",
      "district": "W5"
    },
    "W53": {
      "day": "Sunday",
      "sector": "W5 3",
      "district": "W5"
    },
    "W54": {
      "day": "Sunday",
      "sector": "W5 4",
      "district": "W5"
    },
    "W55": {
      "day": "Sunday",
      "sector": "W5 5",
      "district": "W5"
    },
    "W59": {
      "day": "Sunday",
      "sector": "W5 9",
      "district": "W5"
    },
    "W60": {
      "day": "Sunday",
      "sector": "W6 0",
      "district": "W6"
    },
    "W66": {
      "day": "Sunday",
      "sector": "W6 6",
      "district": "W6"
    },
    "W67": {
      "day": "Sunday",
      "sector": "W6 7",
      "district": "W6"
    },
    "W68": {
      "day": "Sunday",
      "sector": "W6 8",
      "district": "W6"
    },
    "W69": {
      "day": "Sunday",
      "sector": "W6 9",
      "district": "W6"
    },
    "W72": {
      "day": "Sunday",
      "sector": "W7 2",
      "district": "W7"
    },
    "W84": {
      "day": "Sunday",
      "sector": "W8 4",
      "district": "W8"
    },
    "W85": {
      "day": "Sunday",
      "sector": "W8 5",
      "district": "W8"
    },
    "W86": {
      "day": "Sunday",
      "sector": "W8 6",
      "district": "W8"
    },
    "W87": {
      "day": "Sunday",
      "sector": "W8 7",
      "district": "W8"
    },
    "W89": {
      "day": "Sunday",
      "sector": "W8 9",
      "district": "W8"
    },
    "W91": {
      "day": "Sunday",
      "sector": "W9 1",
      "district": "W9"
    },
    "W92": {
      "day": "Sunday",
      "sector": "W9 2",
      "district": "W9"
    },
    "W93": {
      "day": "Sunday",
      "sector": "W9 3",
      "district": "W9"
    },
    "W94": {
      "day": "Sunday",
      "sector": "W9 4",
      "district": "W9"
    },
    "W104": {
      "day": "Sunday",
      "sector": "W10 4",
      "district": "W10"
    },
    "W105": {
      "day": "Sunday",
      "sector": "W10 5",
      "district": "W10"
    },
    "W106": {
      "day": "Sunday",
      "sector": "W10 6",
      "district": "W10"
    },
    "W109": {
      "day": "Sunday",
      "sector": "W10 9",
      "district": "W10"
    },
    "W111": {
      "day": "Sunday",
      "sector": "W11 1",
      "district": "W11"
    },
    "W112": {
      "day": "Sunday",
      "sector": "W11 2",
      "district": "W11"
    },
    "W113": {
      "day": "Sunday",
      "sector": "W11 3",
      "district": "W11"
    },
    "W114": {
      "day": "Sunday",
      "sector": "W11 4",
      "district": "W11"
    },
    "W119": {
      "day": "Sunday",
      "sector": "W11 9",
      "district": "W11"
    },
    "W120": {
      "day": "Sunday",
      "sector": "W12 0",
      "district": "W12"
    },
    "W122": {
      "day": "Sunday",
      "sector": "W12 2",
      "district": "W12"
    },
    "W126": {
      "day": "Sunday",
      "sector": "W12 6",
      "district": "W12"
    },
    "W127": {
      "day": "Sunday",
      "sector": "W12 7",
      "district": "W12"
    },
    "W128": {
      "day": "Sunday",
      "sector": "W12 8",
      "district": "W12"
    },
    "W129": {
      "day": "Sunday",
      "sector": "W12 9",
      "district": "W12"
    },
    "W130": {
      "day": "Sunday",
      "sector": "W13 0",
      "district": "W13"
    },
    "W133": {
      "day": "Sunday",
      "sector": "W13 3",
      "district": "W13"
    },
    "W138": {
      "day": "Sunday",
      "sector": "W13 8",
      "district": "W13"
    },
    "W139": {
      "day": "Sunday",
      "sector": "W13 9",
      "district": "W13"
    },
    "W140": {
      "day": "Sunday",
      "sector": "W14 0",
      "district": "W14"
    },
    "W144": {
      "day": "Sunday",
      "sector": "W14 4",
      "district": "W14"
    },
    "W148": {
      "day": "Sunday",
      "sector": "W14 8",
      "district": "W14"
    },
    "W149": {
      "day": "Sunday",
      "sector": "W14 9",
      "district": "W14"
    }
  }
};
